var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.38 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 252.29,
    y: 116.55,
    width: 74.05,
    height: 69.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.29,
    y: 256,
    width: 74.05,
    height: 69.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.29,
    y: 395.45,
    width: 74.06,
    height: 59.77
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.29 116.55 252.29 56.78 40.71 56.78 40.71 455.22 178.24 455.22 178.24 395.45 252.29 395.45 252.29 325.73 178.24 325.73 178.24 256 252.29 256 252.29 186.27 178.24 186.27 178.24 116.55 252.29 116.55"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m455.38,60v392H60V60h395.38M515.38,0H0v512h515.38V0h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.476cc7698f576f8948b53de0a2b5acfb.svg";
export { ForwardRef as ReactComponent };